/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './add-action.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../$$_gendir/node_modules/ng2-json-editor/src/json-editor.component.ngfactory';
import * as i3 from 'ng2-json-editor/src/json-editor.component';
import * as i4 from 'ng2-json-editor/src/shared/services/app-globals.service';
import * as i5 from 'ng2-json-editor/src/shared/services/problems.service';
import * as i6 from 'ng2-json-editor/src/shared/services/json-store.service';
import * as i7 from 'ng2-json-editor/src/shared/services/json-util.service';
import * as i8 from 'ng2-json-editor/src/shared/services/json-schema.service';
import * as i9 from 'ng2-json-editor/src/shared/services/keys-store.service';
import * as i10 from 'ng2-json-editor/src/shared/services/record-fixer.service';
import * as i11 from 'ng2-json-editor/src/shared/services/schema-fixer.service';
import * as i12 from 'ng2-json-editor/src/shared/services/tabs-util.service';
import * as i13 from 'ng2-json-editor/src/shared/services/path-util.service';
import * as i14 from '@angular/forms';
import * as i15 from '../../../../app/multi-editor/add-action/add-action.component';
import * as i16 from '../autocomplete-input/autocomplete-input.component.ngfactory';
import * as i17 from '../../../../app/multi-editor/autocomplete-input/autocomplete-input.component';
import * as i18 from '../../../../app/multi-editor/shared/services/schema-keys-store.service';
import * as i19 from '@angular/common';
import * as i20 from 'ngx-toastr';
const styles_AddActionComponent:any[] = [i0.styles];
export const RenderType_AddActionComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AddActionComponent,data:{}});
function View_AddActionComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'button',[['class',
      'btn btn-default btn-sm'],['type','button']],(null as any),[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.openEditor()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['Open Editor']))],
      (null as any),(null as any));
}
function View_AddActionComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),11,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      5,'div',[['class','editor']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(4,
      0,(null as any),(null as any),2,'json-editor',([] as any[]),(null as any),[[(null as any),
          'recordChange']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('recordChange' === en)) {
          const pd_0:any = ((<any>_co.saveRecord($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_JsonEditorComponent_0,i2.RenderType_JsonEditorComponent)),i1.ɵdid(5,
      770048,(null as any),0,i3.JsonEditorComponent,[i4.AppGlobalsService,i5.ProblemsService,
          i6.JsonStoreService,i7.JsonUtilService,i8.JsonSchemaService,i9.KeysStoreService,
          i10.RecordFixerService,i11.SchemaFixerService,i12.TabsUtilService,i13.PathUtilService],
      {config:[0,'config'],record:[1,'record'],schema:[2,'schema']},{recordChange:'recordChange'}),
      i1.ɵpod(6,{compact:0}),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),
          i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(9,0,(null as any),
          (null as any),1,'button',[['class','btn-sm btn-default button'],['type',
              'button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.closeEditor()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['Change field'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _ck(_v,6,0,true);
    const currVal_1:any = _co.record;
    const currVal_2:any = _co.subSchema;
    _ck(_v,5,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
export function View_AddActionComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),20,'form',[['class',
      'form-inline'],['novalidate','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'submit'],[(null as any),'reset']],(_v,en,
      $event) => {
    var ad:boolean = true;
    if (('submit' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2).onSubmit($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('reset' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2).onReset()) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(1,16384,(null as any),0,i14.ɵbf,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(2,16384,(null as any),0,i14.NgForm,[[8,
      (null as any)],[8,(null as any)]],(null as any),(null as any)),i1.ɵprd(2048,
      (null as any),i14.ControlContainer,(null as any),[i14.NgForm]),i1.ɵdid(4,16384,
      (null as any),0,i14.NgControlStatusGroup,[i14.ControlContainer],(null as any),
      (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(6,
      0,(null as any),(null as any),1,'label',[['class','form-group']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['Field:'])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵeld(9,0,(null as any),(null as any),1,'re-autocomplete-input',[['name','key'],
          ['type','text']],(null as any),[[(null as any),'valueChange']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i15.AddActionComponent = _v.component;
        if (('valueChange' === en)) {
          const pd_0:any = ((<any>_co.onValueChange($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i16.View_AutocompleteInputComponent_0,i16.RenderType_AutocompleteInputComponent)),
      i1.ɵdid(10,49152,(null as any),0,i17.AutocompleteInputComponent,[i18.SchemaKeysStoreService],
          {disabled:[0,'disabled']},{valueChange:'valueChange'}),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵeld(12,0,(null as any),(null as any),
          7,'div',[['class','form-group']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AddActionComponent_1)),
      i1.ɵdid(15,16384,(null as any),0,i19.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AddActionComponent_2)),
      i1.ɵdid(18,16384,(null as any),0,i19.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i15.AddActionComponent = _v.component;
    const currVal_7:any = _co.isEditorVisible;
    _ck(_v,10,0,currVal_7);
    const currVal_8:any = (_co.isEditorVisible === false);
    _ck(_v,15,0,currVal_8);
    const currVal_9:any = (_co.isEditorVisible === true);
    _ck(_v,18,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,4).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,4).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,4).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,4).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,4).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,4).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,4).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
export function View_AddActionComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-addition-action',
      ([] as any[]),(null as any),(null as any),(null as any),View_AddActionComponent_0,
      RenderType_AddActionComponent)),i1.ɵdid(1,49152,(null as any),0,i15.AddActionComponent,
      [i18.SchemaKeysStoreService,i20.ToastrService],(null as any),(null as any))],
      (null as any),(null as any));
}
export const AddActionComponentNgFactory:i1.ComponentFactory<i15.AddActionComponent> = i1.ɵccf('re-addition-action',
    i15.AddActionComponent,View_AddActionComponent_Host_0,{action:'action'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/add-action/add-action.component.ngfactory.ts